<template>
  <div>
    <b-img center alt="K-9 Logo"
      src="https://res.cloudinary.com/dbl4yeqf9/image/upload/v1577149294/logos/k9corp_njlmb4.png"
      width="275" height="150">
    </b-img>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
}
</script>
